<template>
  <el-container id="noticeGlSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <p style="font-size:20px;margin-left:20px;font-weight:bold;height:20px;line-height:20px">{{ h_text }}</p>
        <div style="margin-top: 10px;padding-left:20px">
          <p>公告标题</p>
          <el-input :disabled="noOperate" v-model="ediTitle" maxlength="30" placeholder="请输入公告标题"
                    style="width:98%"></el-input>
        </div>
        <p style="margin-left:20px;">
          有效时间
        </p>
        <el-date-picker
            v-model="ediTime"
            style="margin-left:20px;"
            type="datetimerange"
            :disabled="noOperate"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
        <div style="margin-top:10px;padding-left:20px;">
          <p>公告详情</p>
          <textarea :disabled="noOperate" v-model="ediDetail" style="width:98%;height:10vh"></textarea>
        </div>
        <div style="display:flex;width:98%">
          <el-button v-if="!noOperate" style="margin-left:auto;margin-right:1px;height:40px" type="info"
                     @click="onBack"
                     icon="el-icon-close">取消
          </el-button>
          <el-button v-if="noOperate"
                     style="margin-right:1px;height:40px;margin-left:auto;" @click="onBack" type="info"
                     icon="el-icon-back">返回
          </el-button>
          <el-button v-if="!noOperate" type="primary" @click="onKeep(2)" icon="el-icon-s-promotion"
                     style="height: 40px">发布
          </el-button>
          <el-button v-if="!noOperate" type="primary" @click="onKeep(1)" style="height: 40px">保存草稿
          </el-button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CryptoJS from 'crypto-js';
import axios from 'axios';

export default {
  name:"noticeGlSon",
  data() {
    return {
      h_text:"新增公告",
      noOperate:false,
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""},
        {"text":"公告管理","colour":"#B7B7B7","pages":""}
      ],
      ediTime:[
        new Date(),
        new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate() + 1,new Date().getHours(),new Date().getMinutes(),new Date().getSeconds())
      ],
      page:1,
      pageSize:10,
      total:0,
      edi_auth:"",
      li_auth:[],
      authPage:1,
      authPageSize:10,
      authTotal:10,
      zhName:"",
      password:"",
      nickName:"", /*账号*/
      value3:"",
      imageUrl:"",
      imageUrl1:"",
      imageId:-1,
      imageId1:-1,
      url_upFile:"",
      ediTitle:"", /*活动名称*/
      ediDetail:"", /*活动详情*/
      ediApplyStart:"", /*报名开始时间*/
      ediApplyEnd:"", /*报名结束时间*/
      ediValidStart:"", /*活动开始时间*/
      ediValidEnd:"", /*活动结束时间*/
      ediMaxApplys:"", /*最大报名个数*/
      ImageUrl:[], /*活动宣传图片*/
      CoverFile:"", /*活动封面图片*/
      CoverFileId:"", /*活动封面图片id*/
      sort:"", /*排序*/
      stateId:1, /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
      id:"",
      isCtr:true,
      isTop:false, /*是否置顶*/
      isBm:false /*是否开启报名限制*/
    };
  },
  computed:{},
  methods:{ /*方法存放*/
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    onKeep(stateId) {
      if (!this.ediTitle) {
        this.$message.info('请先输入公告名称');
        return;
      } else if (!(this.ediDetail)) {
        this.$message.info('请先输入公告内容');
        return;
      } else if (!this.ediTime) {
        this.$message.info('请先选择公告时间');
        return;
      }
      if (this.isCtr) {
        this.isCtr = false;
        if (this.h_text === '新增公告') {
          this.addNotice(stateId);
        } else {
          this.changeNotice(stateId);
        }
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.isCtr = true;
      }
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true; // 如果校验通过，返回true继续上传流程
    },
    uploadFile(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId = response.data.data.id;
            this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess1(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    beforeAvatarUpload1(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true; // 如果校验通过，返回true继续上传流程
    },
    uploadFile1(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId1 = response.data.data.id;
            this.imageUrl1 = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    addNotice(stateId) {
      const params = {
        'title':this.ediTitle,
        'detail':this.ediDetail,
        'stateId':stateId,
        'validStart':parseInt("" + this.ediTime[0].getTime() / 1000),
        'validEnd':parseInt("" + this.ediTime[1].getTime() / 1000), /*结尾+1天*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.newNotify,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加公告成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加公告失败");
        }
      });
    },
    changeNotice(stateId) {
      const params = {
        'id':this.id,
        'title':this.ediTitle,
        'detail':this.ediDetail,
        'stateId':stateId,
        'validStart':parseInt("" + this.ediTime[0].getTime() / 1000),
        'validEnd':parseInt("" + this.ediTime[1].getTime() / 1000), /*结尾+1天*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateNotify,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      if (this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    getNotice(id) {
      const params = {
        'id':id,
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.ediTitle) {
        params["title"] = this.ediTitle; /*角色id*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getNotifyList,params,headers).then(res => {
        console.log("getNotifyList：",res.data.data);
        this.li_notice = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取通知数据失败");
        }
      });
    },
    init_View() {
      let data = this.li_notice[0];
      this.ediTitle = data['title'];
      this.ediDetail = data['detail'];
      if (data['validStart'] && data['validEnd']) {
        this.ediTime = [
          new Date(data["validStart"] * 1000),
          new Date(data["validEnd"] * 1000)
        ];
      } else {
        this.ediTime = [];
      }
    }
  },
  mounted() { /*页面加载时调用*/
    const value = this.$route.query.key;
    if (value === "addNotice") {
      this.h_text = "新增公告";
      this.noOperate = false;
    } else {
      this.id = parseInt(this.$route.query.id);
      if (this.$route.query.operate === 'w') {
        this.noOperate = false;
        this.h_text = "修改公告信息";
      } else {
        this.noOperate = true;
        this.h_text = "查看公告信息";
      }
      this.getNotice(this.id);
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#noticeGlSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/noticeGlSon.vue